import { useEffect, useState } from 'react';
import { Alert, Spinner } from '../common/LegacyUi';
import { useNavigate, useParams } from 'react-router-dom';
import { getSellerReferral } from '../../services/api';
import { normalizePartnerCode, storePartnerCode } from '../../utils/partnerTracking';
import { useAuth } from '../auth/AuthContext';

const AffiliateRedirect = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const { currentUser, loading, isAuthenticated } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    if (loading) return undefined;

    let cancelled = false;
    const normalizedCode = normalizePartnerCode(code);

    const resolvePartner = async () => {
      if (!normalizedCode) {
        setError('Este link no es válido.');
        return;
      }

      try {
        const response = await getSellerReferral(normalizedCode);
        if (cancelled) return;

        const partnerCode = storePartnerCode(response.data.code || normalizedCode);
        const next = '/business/payment/plans';

        if (isAuthenticated && currentUser?.user_type === 'business') {
          navigate(`${next}?partner=${encodeURIComponent(partnerCode)}`, { replace: true });
          return;
        }

        if (isAuthenticated && currentUser?.user_type && currentUser.user_type !== 'none') {
          navigate('/dashboard', { replace: true });
          return;
        }

        navigate(`/login?partner=${encodeURIComponent(partnerCode)}&next=${encodeURIComponent(next)}`, {
          replace: true,
        });
      } catch (err) {
        if (!cancelled) {
          setError('No pudimos reconocer este link. Revisa que esté escrito correctamente.');
        }
      }
    };

    resolvePartner();
    return () => {
      cancelled = true;
    };
  }, [code, currentUser, loading, navigate, isAuthenticated]);

  if (error) {
    return (
      <div className="container py-5">
        <Alert variant="danger">{error}</Alert>
      </div>
    );
  }

  return (
    <div className="container py-5 text-center">
      <Spinner animation="border" />
      <p className="mt-3">Preparando tu acceso a FOTH...</p>
    </div>
  );
};

export default AffiliateRedirect;
